import React from "react";
import { withRouter } from "react-router-dom";

function ExtraItems(props) {
  const { extra_request_items } = props;
  console.log(extra_request_items, "Extra");
  return (
    <div className="info-detail-wrapper p-3 pt-20">
      <div className="row">
        <div className="col-12 col-sm-5">
          {/* <div className="row pt-1">
            <div className="col-9 text-left small-font-size">Packing kit</div>
            <div className="col-3 small-sub-title">
              <span className="pr-2 align-bottom">5</span>
            </div>
          </div> */}
          {/* display extra item list */}
          {extra_request_items.map(
            (item, i) =>
              item.quantity > 0 && (
                <div key={i} className="row pt-1">
                  <div className="col-6 text-left small-font-size">
                    {item.name}
                  </div>
                  <div className="col-3 small-sub-title">{item.quantity} </div>
                  <div className="col-3 small-sub-title">
                    ${item.unit_price * item.quantity}{" "}
                  </div>
                </div>
              )
          )}
        </div>
      </div>
      <div className="row mt-4 pb-2">
        <div className="col-12 justify-content-center d-flex">
          <button
            className="custom-btn-small custom-buton"
            onClick={() =>
              props.history.push(
                "/admin/request/edit-extra-items/" + props.match.params.id
              )
            }
          >
            Edit
          </button>
        </div>
      </div>
    </div>
  );
}

export default withRouter(ExtraItems);
